import React from 'react';
import ProjectLayout from './projectlayout'
import {ProjectOne,ProjectTwo,ProjectThree} from './projectdata'
import styled from 'styled-components'

const Container = styled.div`
margin: 120px auto;
width: 66%;

@media screen and (max-width:1886px){
    margin: 30px auto;
    width: 76%;

 }
@media screen and (max-width:1029px){
    margin: 30px auto;
    width: 52%;

 }
@media screen and (max-width:786px){
    margin: 30px auto;
    width: 52%;
 }
@media screen and (max-width:536px){    
    margin: 30px auto;
    width: 78%;
 }
 @media screen and (max-width:373px){    
    margin: 30px auto;
    width: 92%;
 }
`
const Column1 = styled.div`
display: flex;
justify-content: center;
flex-flow: row wrap;
@media screen and (max-width:786px){
     flex-direction: column;

 }

`
const TopLine = styled.p`
text-align: center;
    color: #01bf71;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin: 50px 117px;

@media screen and (max-width:786px){
    margin: 25px 0px;

 }
`
export default function projects() {

    return(
        <Container id='projects'>
            <TopLine>Projects</TopLine>
            <Column1>
        <ProjectLayout {...ProjectOne}/>
        <ProjectLayout {...ProjectTwo}/>
        <ProjectLayout {...ProjectThree}/> 
            </Column1>

        </Container>
    )


}